/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../../resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "service": {
                    "nested": {
                      "UpdateItemModifierListsRequest": {
                        "fields": {
                          "itemIds": {
                            "type": "string",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "modifierListsToEnable": {
                            "type": "string",
                            "id": 2,
                            "rule": "repeated"
                          },
                          "modifierListsToDisable": {
                            "type": "string",
                            "id": 3,
                            "rule": "repeated"
                          }
                        }
                      },
                      "UpdateItemModifierListsResponse": {
                        "fields": {
                          "errors": {
                            "type": ".squareup.connect.v2.resources.Error",
                            "id": 1,
                            "rule": "repeated"
                          },
                          "updatedAt": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateItemModifierListsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.service?.nested?.UpdateItemModifierListsResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE UpdateItemModifierListsRequest @ squareup/connect/v2/catalog/interfaces/update-item-modifier-lists.proto at 18:1
 */
export const UpdateItemModifierListsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateItemModifierListsRequest');
fixType(UpdateItemModifierListsRequest, {
  itemIds: {
    required: true
  }
});
Builder.createAndAttachToType(UpdateItemModifierListsRequest);
/**
 * SOURCE UpdateItemModifierListsResponse @ squareup/connect/v2/catalog/interfaces/update-item-modifier-lists.proto at 35:1
 */
export const UpdateItemModifierListsResponse = $root.lookupType('squareup.connect.v2.merchant_catalog.service.UpdateItemModifierListsResponse');
fixType(UpdateItemModifierListsResponse);
Builder.createAndAttachToType(UpdateItemModifierListsResponse);